import type { FC } from 'react'
import { Box } from '@mui/material'
import { ShopIcon } from '@dhl-ui/icons'
import { type ServicepointInputValue, toServicepointLabel } from '@dhl/servicepoint-input'
import { Body1 } from '@dhl-ui/components'

type Props = {
  data: ServicepointInputValue | null
}

export const DisplayServicePointValue: FC<Props> = ({ data: servicePoint }) => (
  <Box display="flex" flexDirection="row">
    <ShopIcon sx={{ mr: 1, mt: -0.5 }} />
    <Body1 component="span">{servicePoint ? toServicepointLabel(servicePoint) : ''}</Body1>
  </Box>
)
